<template>
  <div>
    <div class="row">
      <div class="col-12 display-flex">
        <div class="col-3 dx-field">
          <div class="dx-field-label">AREA</div>
          <div class="dx-field-value">
            <DxSelectBox
              v-model:value="selectedArea"
              :data-source="areaFilterData"
              display-expr="name"
              :show-clear-button="true"
              placeholder="Tutte"
              @value-changed="areaFilterChange"
            />
          </div>
        </div>
        <div class="col-3 dx-field">
          <div class="dx-field-label">AREA TEMATICA</div>
          <div class="dx-field-value">
            <DxSelectBox
              id="areaTematicaFilter"
              v-model:value="selectedAreaTematica"
              :data-source="areaTematicaFilterData"
              display-expr="name"
              :show-clear-button="true"
              placeholder="Tutte"
            />
          </div>
        </div>
        <div class="col-6 dx-field">
          <div class="dx-field-label">RICERCA LIBERA</div>
          <div class="dx-field-value">
            <DxTextBox
              v-model:value="searchValue"
              class="col-12"
              placeholder="Cerca"
              :show-clear-button="true"
            >
              <DxTextBoxButton
                :options="searchButtonOptions"
                name="searchKey"
                location="after"
              />
            </DxTextBox>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <DxDataGrid
          id="grid"
          ref="grid"
          :data-source="gridItems"
          :show-borders="true"
          :word-wrap-enabled="true"
          @cell-prepared="onCellPrepared"
        >
          <DxFilterRow :visible="true" />
          <DxHeaderFilter :visible="true" />
          <DxColumn
            caption=""
            cell-template="iconaTemplate"
            alignment="center"
            :width="100"
            :allow-sorting="false"
          />
          <DxColumn
            data-field="typeDescription"
            caption="TIPOLOGIA"
            :editor-options="{ showClearButton: true }"
            :width="300"
            :filter-operations="allowedGridHeaderOperations"
          />
          <DxColumn
            data-field="title"
            caption="TITOLO"
            :editor-options="{ showClearButton: true }"
            :allow-header-filtering="false"
            :filter-operations="allowedGridHeaderOperations"
          />
          <DxColumn
            data-field="teachers"
            caption="DOCENTI"
            :editor-options="{ showClearButton: true }"
            :filter-operations="allowedGridHeaderOperations"
          />
          <DxColumn
            data-field="duration"
            caption="ORE"
            width="110"
            :editor-options="{ showClearButton: true }"
            :calculate-cell-value="calculateDurationCellValue"
            :filter-operations="allowedGridHeaderOperations"
          />
          <DxColumn
            caption="PREZZO"
            cell-template="subscribeTemplate"
            :allow-search="false"
            :allow-sorting="true"
            :calculate-cell-value="calculateCellValue"
            width="200"
            alignment="center"
          />
          <template #subscribeTemplate="{ data }">
            <div
              style="
                text-align: center;
                vertical-align: middle !important;
                padding: 10px;
              "
            >
              <div class="price-field">
                <span> {{ data.data.price }}</span> + IVA
              </div>
              <DxButton
                text="ACQUISTA ONLINE"
                type="default"
                styling-mode="outlined"
                :data-utid="userId"
                :data-abbid="data.data.iD_Abbonamento"
                :data-abbcode="data.data.codice_Abbonamento"
                :data-id="data.data.iD_Documento"
                data-tipou="0"
                @click="AddProduct(53847)"
              />
              <!-- <a class="button addECProduct" href="" data-utid="data.data.id" data-abbid="28383" data-abbcode="8PASS-4631-4631-20200701-20210630" data-id="56294" data-tipou="1" @click.prevent="subscribeAlert(data.data)">ISCRIVITI</a> -->
            </div>
          </template>
          <template #iconaTemplate="{ data }">
            <div
              style="
                text-align: center;
                vertical-align: middle !important;
                padding: 10px;
              "
            >
              <!-- TODO: fix immagini -->
              <img
                v-if="data.data.typeId === 19"
                src="img/SEMINARI.png"
                title=""
              />
              <img v-else src="img/PERCORSI.png" title="" />
            </div>
          </template>
          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data }">
            <EcPassELearningDetail :item="data.key" />
          </template>
          <DxPager
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 20, 50]"
            :show-navigation-buttons="true"
            :show-info="true"
          />
          <DxPaging :page-size="10" />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import 'devextreme/data/odata/store'
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxMasterDetail,
} from 'devextreme-vue/data-grid'
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box'
import DxSelectBox from 'devextreme-vue/select-box'
import { DxButton } from 'devextreme-vue/button'
import EcPassELearningDetail from './EcPassELearningDetail'

import { mapGetters } from 'vuex'
import * as actionTypes from '@/store/module-area-pubblica/actionTypes'

export default {
  name: 'EcPassELearning',
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxSelectBox,
    DxPager,
    DxPaging,
    DxMasterDetail,
    EcPassELearningDetail,
    DxTextBox,
    DxTextBoxButton,
    DxButton,
  },
  data: () => ({
    selectedAreaTematica: null,
    selectedArea: null,
    searchValue: '',
    gridData: [],
    errors: [],
    allowedGridHeaderOperations: ['contains'],
    selectedGridHeaderOperation: 'contains',
    userId: 0,
    categoryId: 42, // TODO get category
    searchButtonOptions: {
      icon: 'search',
      type: 'normal',
    },
  }),
  computed: {
    ...mapGetters(['areaList', 'areaTematicaList', 'regioneList']),
    gridItems() {
      let items = this.gridData
      if (this.selectedAreaTematica) {
        items = items.filter(i =>
          i.areeTematicheIds.includes(this.selectedAreaTematica.id)
        )
      }
      if (this.selectedArea) {
        items = items.filter(i => i.areeIds.includes(this.selectedArea.id))
      }
      if (this.searchValue) {
        items = items.filter(i =>
          i.title.toLowerCase().includes(this.searchValue.toLowerCase())
        )
      }
      return items
    },
    areaFilterData() {
      const availableAreaIds = [
        ...new Set(this.gridItems.map(item => item.areeIds).flat()),
      ]
      return this.areaList.filter(i => availableAreaIds.includes(i.id))
    },
    areaTematicaFilterData() {
      const areeTematicheIds = [
        ...new Set(this.gridItems.map(g => g.areeTematicheIds).flat()),
      ]
      return this.selectedArea
        ? this.areaTematicaList.filter(
            i =>
              areeTematicheIds.includes(i.id) &&
              i.groupId === this.selectedArea.id
          )
        : this.areaTematicaList.filter(i => areeTematicheIds.includes(i.id))
    },
  },
  mounted() {
    this.userId = localStorage.getItem('UserID')

    Promise.all([
      this.$store.dispatch(actionTypes.GET_AREA_LIST),
      this.$store.dispatch(actionTypes.GET_AREA_TEMATICA_LIST),
    ])
      .then(res => {
        this.gridData = res
      })
      .catch(e => {
        this.errors.push(e)
      })

    this.apiService.areaPubblicaApi
      .getELearningClassList(this.categoryId)
      .then(res => {
        res.forEach(element => {
          this.gridData.push({
            id: element.cO_ID,
            title: element.cO_Titolo,
            typeId: element.cO_Tipo_Doc,
            typeDescription: element.tipoDocumento,
            area: element.nomi_aree,
            duration: element.durata,
            areeIds: this.formatAreeIds(element.id_aree),
            areeTematicheIds: this.formatAreeIds(element.id_aree_tematiche),
            highlight: element.prodotto_novita,
            teachers: element.docenti_elenco
              .replace(/\|\|/g, ', ')
              .replace(/[|]/g, ''),
            price: element.prezzo_finale,
            details: this.formatDetails(element.datiAccreditamento),
          })
        })
      })
  },
  methods: {
    areaFilterChange() {
      this.selectedAreaTematica = null
    },
    subscribeAlert(data) {
      alert(`Tentativo di iscrizione a corso con id ${data.id}`)
      return false
    },
    formatAreeIds(areeIds) {
      const areeIdsStringArray = areeIds.split('||')
      const areeIdsIntArray = areeIdsStringArray.map(a => {
        return parseInt(a.replace(/[|]/g, ''))
      })
      return areeIdsIntArray
    },
    formatDetails(datiAccreditamento) {
      if (datiAccreditamento === '') {
        return []
      }
      const datiAccreditamentoArray = datiAccreditamento.split('||')
      const details = datiAccreditamentoArray.map(d => {
        const detailsArray = d.split('§')
        return {
          categoria: detailsArray[0].replace('|', ''),
          stato: detailsArray[1],
          cfp: detailsArray[2],
          scadenzaCrediti:
            detailsArray[3] === '01/01/1900|'
              ? ''
              : detailsArray[3].replace('|', ''), // TODO check this
        }
      })
      return details
    },
    calculateDurationCellValue(data) {
      if (
        data.typeId === 19 ||
        data.typeId === 20 ||
        data.typeId === 21 ||
        data.typeId === 68
      ) {
        return parseFloat(data.duration).toFixed(0)
      } else {
        return parseFloat(data.duration).toFixed(0) + ' gg'
      }
    },
    getDateFromString(stringDate) {
      const splittedDate = stringDate.split('/')
      const date = [splittedDate[1], splittedDate[0], splittedDate[2]].join('/')
      return new Date(date)
    },
    onCellPrepared(e) {
      if (e.rowType === 'data' && e.column.command === 'expand') {
        if (e.data.details.length === 0) {
          e.cellElement.classList.remove('dx-datagrid-expand')
          e.cellElement.firstElementChild.classList.add('hidden-row')
        }
      }
    },
    calculateCellValue(data) {
      if (!data || !data.price) {
        return '0'
      }
      return data.price
    },
  },
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.price-field {
  margin-bottom: 10px;
}
.price-field span {
  font-weight: bolder;
}
.button {
  background: rgb(0, 158, 220);
}
a {
  background: rgb(0, 158, 220);
}
.display-flex {
  display: flex;
  align-items: baseline;
}
.filter-element {
  padding-left: 1rem;
}
.date-filter-element .dx-field-label {
  width: 30%;
}
.date-filter-element .dx-field-value {
  width: 70%;
}
</style>
<style>
.hidden-row {
  visibility: hidden !important;
}
.dx-texteditor-input {
  margin: 0 !important;
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.87) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -webkit-appearance: none !important;
  outline: 0 !important;
  border: 0 !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}
</style>
